import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Maps internal doc key → API documentName value (the isXxx flag name).
 * These match the boolean field names in the get-entities API response.
 */
export const DOC_KEY_TO_APPROVE_NAME = {
  doc_aadhar: "isAadharCard",
  doc_pan: "isPANCard",
  doc_partnershipDeed: "isPartnershipDeed",
  doc_aadharBoth: "isAadharOfBothPartners",
  doc_llpCertificate: "isLLPCertificate",
  doc_coi: "isCertificateOfIncorporation",
  doc_directorPan: "isDirectorPan",
  doc_directorAadhar: "isDirectorAadhar",
  doc_trustDeed: "isTrustDeed",
  doc_panTrust: "isPANOfTrust",
  doc_panTrustee: "isPANOfTrustee",
  doc_aadharTrustee: "isAadharOfTrustee",
  doc_msme_certificate: "isMSMECertificate",
  doc_utility_bill: "isUtilityBillDocument",
  doc_bank_proof: "isPassbookOrCancelledCheque",
  third_party_file: "isSignedForm",
};

/**
 * Resolves the API documentName for a given doc key.
 * GST certs (gst_file_0, gst_file_1, …) always map to "isGST".
 */
export const resolveDocumentName = (docKey) => {
  if (/^gst_file_\d+$/.test(docKey)) return "isGST";
  return DOC_KEY_TO_APPROVE_NAME[docKey] || docKey;
};

/**
 * Approves a single document.
 * POST api/Onboarding/approve-document
 *
 * @param {object} params
 * @param {number} params.entityPrimaryId  - entity primary ID
 * @param {number|null} params.gstId       - GST entry ID (for GST docs), null for all others
 * @param {string} params.documentName     - isXxx flag name (e.g. "isPANCard")
 * @param {string} params.approvedBy       - logged-in user name
 */
export const approveDocumentAction = async ({
  entityPrimaryId,
  gstId = null,
  documentName,
  approvedBy,
}) => {
  try {
    const payload = {
      entityPrimaryId: entityPrimaryId || 0,
      gstId: gstId ?? null,
      documentName: documentName || "",
      approvedBy: approvedBy || "",
    };

    console.log("[ApproveDocument] payload:", payload);

    const response = await apiClient.post(
      ATP_API_URL.APPROVE_DOCUMENT,
      payload,
    );

    if (response?.status === 200) {
      if (response.data?.success === false) {
        return {
          success: false,
          message: response.data.message || "Failed to approve document",
        };
      }
      return {
        success: true,
        message: response.data?.message || "Document approved successfully",
      };
    }

    return { success: false, message: "Failed to approve document" };
  } catch (error) {
    console.error("[ApproveDocument] error:", error);
    return {
      success: false,
      message: error.message || "Failed to approve document",
    };
  }
};
